import { render } from "./DiscardAuthentication.vue?vue&type=template&id=19c7c7e8&ts=true"
import script from "./DiscardAuthentication.vue?vue&type=script&lang=ts"
export * from "./DiscardAuthentication.vue?vue&type=script&lang=ts"

import "./DiscardAuthentication.vue?vue&type=style&index=0&id=19c7c7e8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__